import React from 'react';
import BaristaBot from '../img/barista-bot.svg';
import GreatTeam from '../img/great-team.svg';
import FooterCopy from './FooterCopy';

const SmallFooter = () => {
  return (
    <footer className="small-footer">
      <div className="small-footer-content">
        <div className="small-footer-bot">
          <img src={GreatTeam} alt="Bot" className="small-footer-bot" />
        </div>
      </div>
      <img src={BaristaBot} alt="Barista Bot" className="small-footer-baristabot" />
      <div className="sf-social-media-buttons">
        <a href="https://instagram.com/baristabot_app" target="_blank" rel="noopener noreferrer" className="sf-social-button instagram">Instagram ↗</a>
        <a href="https://x.com/baristabot_app" target="_blank" rel="noopener noreferrer" className="sf-social-button twitter">Twitter/X ↗</a>
        <a href="https://notes.baristabot.app" target="_blank" rel="noopener noreferrer" className="sf-social-button substack">Substack ↗</a>
      </div>
      <div className="small-footer-copy">
        <FooterCopy />
      </div>
    </footer>
  );
};

export default SmallFooter;
